import React, { createContext, ReactNode, useContext } from 'react';

type ContextType = {
  provider: CachedDataProvider | null;
};

type CachedDataProvider = Record<string, never>;

const CachedDataProviderContext = createContext<ContextType | null>(null);

export const CachedDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <CachedDataProviderContext.Provider value={{ provider: {} }}>{children}</CachedDataProviderContext.Provider>;
};

export const useCachedDataProvider = () => {
  const context = useContext(CachedDataProviderContext);
  if (!context?.provider) throw new Error('useCachedDataProvider must be used within a CachedDataProviderContext');
  return context.provider;
};
